import type { ModernSubscription } from '../../types';

import { hasPlan } from './hasPlan';

export function isInvoiced(modernSubscription: ModernSubscription) {
  return !modernSubscription.periodEndDate && hasPlan(modernSubscription);
}
